import { Component, inject, OnDestroy, OnInit, Signal } from '@angular/core';
import {
  ConfirmationService,
  MessageService,
  PrimeTemplate,
} from 'primeng/api';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuctionService } from '../../services/auction.service';
import { AuctionModel } from '../../models/auction.model';
import { GalleriaModule } from 'primeng/galleria';
import { BreakpointObserver } from '@angular/cdk/layout';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { Toast, ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-summary-auction-page',
  imports: [
    Button,
    InputText,
    ReactiveFormsModule,
    GalleriaModule,
    PrimeTemplate,
    ToastModule,
  ],
  templateUrl: './summary-auction-page.component.html',
  styleUrl: './summary-auction-page.component.scss',
})
export class SummaryAuctionPageComponent implements OnInit, OnDestroy {
  public form: FormGroup<{ email: FormControl<string | null> }> = new FormGroup(
    {
      email: new FormControl('', [Validators.required]),
    }
  );
  public firstItemEngagementCount: number = 0;
  public secondItemEngagementCount: number = 0;
  public isMobile = false;
  public isTablet = false;
  public isDesktop = false;
  public firstImages: Array<
    string | { src: string; thumb?: string; alt?: string }
  > = [];
  public secondImages: Array<
    string | { src: string; thumb?: string; alt?: string }
  > = [];
  private auctionService = inject(AuctionService);
  private router: Router = inject(Router);

  public readonly auctionDetails: AuctionModel =
    this.auctionService.auctionProducts();
  public readonly firstProductReservations: number =
    this.auctionService.firstProductReservations();
  public readonly secondProductReservations: number =
    this.auctionService.secondProductReservations();

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe(['(max-width: 768px)', '(max-width: 1200px)'])
      .subscribe((result) => {
        if (result.breakpoints['(max-width: 768px)']) {
          this.isMobile = true;
          this.isTablet = false;
          this.isDesktop = false;
        } else if (result.breakpoints['(max-width: 1200px)']) {
          this.isTablet = true;
          this.isMobile = false;
          this.isDesktop = false;
        } else {
          this.isDesktop = true;
          this.isTablet = false;
          this.isMobile = false;
        }
      });
  }

  ngOnInit() {
    const details = this.auctionDetails;
    if (!details) {
      return;
    }
    this.firstImages = (details.firstItem?.product?.images ?? []).map(
      (img) => img.url ?? img
    );
    this.secondImages = (details.secondItem?.product?.images ?? []).map(
      (img) => img.url ?? img
    );
  }

  onSubmit(): void {
    if (this.form.value.email) {
      this.auctionService
        .sendUserEmail(this.form.value.email, this.auctionDetails.id)
        .subscribe(() => {
          this.router.navigate([''], {
            replaceUrl: true,
            state: {
              toast: {
                severity: 'success',
                summary: 'Pomyślnie wysłano email!',
              },
            },
          });
        });
    }
  }

  ngOnDestroy(): void {
    this.auctionService.auctionProducts.set({} as AuctionModel);
    this.auctionService.firstProductReservations.set(0);
    this.auctionService.secondProductReservations.set(0);
  }

  normalizeImg = (
    img: string | { src: string; thumb?: string; alt?: string }
  ) =>
    typeof img === 'string'
      ? { src: img, thumb: img, alt: '' }
      : { thumb: img.src, alt: '', ...img };
}
